// extracted by mini-css-extract-plugin
export default {"loader":"loopAnimation_loader__YPbJz","spin":"loopAnimation_spin__A5+rT"};